import { string, object, number, ref } from "yup";

import addressSchema from "../../../utils/common-schemas/Address-schema";

const email = string().email();

const crecheInformationSchema = object().shape({
  nom: string().required("Le nom est obligatoire"),
  logoId: string(),
  adresseCreche: addressSchema
});

const agentSchema = object().shape({
  nom: string().required("Le nom est obligatoire"),
  prenom: string().required("Le prénom est obligatoire"),
  email: email.required("L'email est obligatoire"),
  numeroTel: number(),
  fonction: string()
});

const accountInformationSchema = object().shape({
  identifiant: email.required("l'identifiant est obligatoire"),
  motDePasse: string()
    .required("le mot de passe est obligatoire")
    .min(
      8,
      "Le mot de passe est trop court - il devrait contenir au moins 8 caractères."
    ),
  comfirmerMotDePasse: string()
    .required("confirmer le mot de passe est obligatoire")
    .oneOf(
      [ref("motDePasse"), null],
      "Mot de passe et confirmer le mot de passe ne correspond pas"
    ),
  agentCrecheDto: agentSchema
});

const crecheSchema = object().shape({
  crecheDto: crecheInformationSchema,
  compteRequestDto: accountInformationSchema
});

export default crecheSchema;
